import React from "react";
import { motion } from "framer-motion";
import { Sparkles, Droplets, Feather } from "lucide-react";
import { BENEFITS } from "@/constants/testIds";

const ease = [0.22, 1, 0.36, 1];

const items = [
  {
    n: "01",
    title: "Difuzie inspirată de skincare",
    body: "Un micro-mist fin care se așază uniform pe piele.",
    Icon: Droplets,
    testid: BENEFITS.card1,
  },
  {
    n: "02",
    title: "Luminozitate naturală",
    body: "Piele care arată îngrijită, fără strălucire artificială.",
    Icon: Sparkles,
    testid: BENEFITS.card2,
  },
  {
    n: "03",
    title: "Fără timp de așteptare",
    body: "Pulverizezi și mergi mai departe cu ziua ta.",
    Icon: Feather,
    testid: BENEFITS.card3,
  },
];

export default function Benefits() {
  return (
    <section
      id="benefits"
      data-testid={BENEFITS.section}
      className="relative py-28 md:py-40 bg-[#F4F0EA]"
    >
      <div className="mx-auto max-w-[1400px] px-6 md:px-12 lg:px-16">
        <motion.div
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 1, ease }}
          className="max-w-2xl mb-16 md:mb-24"
        >
          <p className="overline mb-12">— Trei motive</p>
          <h2 className="font-display text-3xl sm:text-4xl md:text-5xl text-[#2C2826] leading-[1.15] tracking-[-0.01em]">
            Mai puțin produs.
            <br />
            <span className="accent-soft">
              Mai mult confort.
            </span>
          </h2>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-px bg-[#E5DCD3]">
          {items.map((it, i) => (
            <motion.article
              key={it.n}
              data-testid={it.testid}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ duration: 0.9, ease, delay: i * 0.12 }}
              className="group relative bg-[#FDFBF7] p-10 md:p-12 lg:p-14 flex flex-col min-h-[340px] hover:bg-white transition-colors duration-500"
            >
              <div className="flex items-start justify-between mb-12">
                <span className="overline">{it.n}</span>
                <it.Icon
                  className="w-5 h-5 text-[#2C2826]/70 group-hover:text-[#2C2826] transition-colors duration-500"
                  strokeWidth={1.2}
                />
              </div>

              <h3 className="font-serif-classic text-2xl md:text-[1.7rem] text-[#2C2826] leading-tight mb-4 tracking-[-0.005em]">
                {it.title}
              </h3>
              <p className="text-[15px] leading-[1.8] text-[#5C5652] font-light">
                {it.body}
              </p>

              <div className="mt-auto pt-10">
                <div className="w-0 group-hover:w-12 h-px bg-[#2C2826] transition-all duration-700" />
              </div>
            </motion.article>
          ))}
        </div>
      </div>
    </section>
  );
}
